import Vue from 'vue';
import VeeValidate from 'vee-validate';

// changes the locale (om det behövs, endast 1 gg per "entry point"):
import VeeValidateLocaleSv from 'VeeValidateLocaleSv';		
VeeValidateLocaleSv.runOnce();	// Kör funktionen om den inte redan körts!

window.ssoAllaSidor = window.ssoAllaSidor || {};	// För att undvika ESLint-varningar att den är odefinierad.


// Se https://baianat.github.io/vee-validate/configuration.html:
// Obs! Vissa av dessa har nog "Manual installation" nedan och/eller endast använder komponenterna ValidationObserver/ValidationProvider;

const config = {
	// Dessa har bara bärighet på rena HTML5 inputs. Egna komponenter – icke!
	// https://baianat.github.io/vee-validate/guide/classes-and-styling.html#auto-css-classes
	aria: true,
	classNames: {},
	classes: true,

	delay: 0,
	dictionary: null,
	errorBagName: 'veeValidateErrors',
	events: 'blur',	// ..ingen bärighet då vi använder //'input|blur|change',		// Själv lagt till 'change'. *Men*, denna har ev ingen bäring, se kommentar ovan.
	fieldsBagName: 'veeValidateFields',
	fastExit: true,
	i18n: null, // the vue-i18n plugin instance
	i18nRootKey: 'validations', // the nested key under which the validation messages will be located

	// Specifies if a validator instance should be injected automatically for all components:
	// inject:false är för att den inte ska injecta en massa errors-objekt på alla/omotiverade komponenter/element. Behövs inte då vi endast använder komponenterna ValidationObserver/ValidationProvider:
	inject: false,	

	locale: 'sv',

	// Set custom validity Constraint validation on native HTML inputs. Also enables rule inference on native HTML inputs.
	validity: false
};


// ersatt med "global" variabel i namespacet window.ssoAllaSidor:
//let redanKord = false;

export default {

	runOnce() {

		if (!window.ssoAllaSidor.veeValidateInstance)
		{
			// Om den "globala" variabeln i namespacet window.ssoAllaSidor *inte* redan 'r tilldelad:

			//redanKord = true;

			// Manual Installation
			// You might be interested in using VeeValidate exposed components as you see fit without having to install the plugin, you can do this by creating an instance of the VeeValidate plugin.
			// Using this method will not add any directives, mixins, or components to your app, instead it passes everything vee-validate needs to set itself up and you will be responsible for using the plugin manually which is helpful if you are only planning to use standalone features like the Validator.verify API.
			// Bästa sättet då vi endast använder komponenterna ValidationObserver/ValidationProvider:

			window.ssoAllaSidor.veeValidateInstance = new VeeValidate(config, Vue);


			// Validerings-mode 'eager' är problematisk, för den växlar mellan 'change' och 'input'. Se varför i mitt inlägg på https://github.com/baianat/vee-validate/issues/1989.
			// Svar på inlägget från Abdelrahman Awad: "I guess change was a poor choice since it does not work as expected, I will probably add both blur and change since some inputs do not emit blur.".

			// Vi skapar därför en egen mode som istället validerar vid 'blur'/'change' resp 'input'. Dessutom debounceas input lite (bra, inte minst vid remote validering):
			// Info och exempel: https://baianat.github.io/vee-validate/guide/interaction.html#custom-modes

			VeeValidate.setMode('eagerMedBlurOchDebounce', ({ errors, flags, value, failedRules }) =>
			{
				// become slightly aggressive if the field is invalid.
				if (errors.length)
				{
					return {
						on: ['input'],
						debounce: 350
					};
				}

				// validate immediately after leaving the field.
				return {
					// På prov: *Ingen* validering alls vid blur/change:
					//on: ['blur', 'change'],		// Was: ['change'],
					on: [],
					debounce: 200	// Även lite debounce här, så täcker vi i många fall in caset att man väljer Avbryt i dialog med felvaliderande formulär ;)  (och slipper därmed koda det korrekt).
				};
			});

			
		}
	}
}
	
